import logoAsset from "@/assets/skl-logo-aqua.png.asset.json";

export function LogoMark({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <img
      src={logoAsset.url}
      alt="SKL-Flow logo"
      className={className}
      loading="eager"
      decoding="async"
    />
  );
}

export function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoMark className="h-8 w-8 rounded-md" />
      <span className="font-bold text-lg text-foreground tracking-tight">{"\n"}</span>
    </div>
  );
}
